import { Grid2, Typography } from '@mui/material';
import { PaymentLinkStatus } from '@utriper/core';
import { CircularIndeterminate } from '@utriper/core-ui';
import { useCheckout } from 'core/contexts/checkout';
import React, { useEffect } from 'react';
import { useTranslation } from '../../../../core/contexts/localization';

const PaymentProcessing = ({ status, accessCode }) => {
    const { t: translate } = useTranslation();
    const { validateCheckout } = useCheckout();

    useEffect(() => {
        if (status !== PaymentLinkStatus.IDS.processing) {
            return;
        }

        const interval = setInterval(() => {
            validateCheckout(accessCode);
        }, 5000);

        return () => clearInterval(interval);
    }, [status]);

    return (
        <Grid2 container direction="column">
            <CircularIndeterminate centered styles={{ marginLeft: '3em' }}/>
            <Typography
                variant="inherit"
                component="span"
                sx={{
                    position: 'absolute',
                    top: '40%',
                    alignSelf: 'center',
                }}>
                {translate('checkout.paymentInProcess')}
            </Typography>
        </Grid2>
    );
};

export default PaymentProcessing;
